/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
export default function FeaturedProducts() {
    const [brands, setBrands] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    let navigate = useNavigate();
    async function getBrands() {
        setIsloading(true)
        let { data } = await axios.get(`https://ecommerce.routemisr.com/api/v1/brands`);
        setBrands(data.data);
        setIsloading(false)
    }
    function getBrandId(id) {
        navigate(`/brandDetails/${id}`); // Navigate with the product ID
    }
    useEffect(() => {
        getBrands();
    }, []);

    return (
        <>
            <Helmet>
                <title>Brands</title>
            </Helmet>
            <div className="row mt-5">
                {isLoading ? <div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div> : <>
                    {brands.map((brand) => (
                        <div key={brand._id} className="col-md-2 py-4 mb-5" onClick={() => getBrandId(brand._id)}>
                            <div className="product cursor-pointer px-2 py-3">
                                <img className="w-100" src={brand.image} alt="" />
                                <span className="text-main fw-bold font-sm">{brand.name}</span>
                            </div>
                        </div>
                    ))}
                </>}
            </div>
        </>
    );
}
